import React, { useContext, useEffect } from 'react'
import { IonContent, IonIcon, IonPage, IonRouterLink, IonText, useIonToast } from '@ionic/react'
import { StyleIonHeader, TextStyle, DetailContent } from '../../../components'
import styled from 'styled-components'
import { StoresContext } from '../../../provider/StoreProvider'
import { RouteComponentProps } from 'react-router'
import { chevronForward, gridOutline, shareSocialOutline } from 'ionicons/icons'
import { observer } from 'mobx-react'
import moment from 'moment-timezone'
import { amountString, onCopyContent } from '../../../common'

type Props = RouteComponentProps<{
  productId: string
}>

export const ProductDescription: React.FC<Props> = observer(({ match }) => {
  const { myStore } = useContext(StoresContext)
  let loadParam = { productId: Number(match.params.productId) }
  const [presentToast] = useIonToast()
  const detailStore = myStore.productDetailStore

  useEffect(() => {
    loadParam = { productId: Number(match.params.productId) }
    detailStore.load({ param: loadParam })
  }, [match.params.productId])

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={''} href={`/myPage/asset/${match.params.productId}`} />
      <IonContent>
        <DetailContent detailStore={detailStore}>
          <ImgWrap>
            <img
              src={detailStore.content?.imageUri}
              alt={detailStore.content?.name}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null
                currentTarget.src = '/img/thumbnail.svg'
              }}
            />
          </ImgWrap>
          <ContentContainer>
            <ProductHeaderContainer>
              <ProductInfoWrap>
                <TextStyle type={'r_13'} color={'primary_light'}>
                  {detailStore.content?.artist}
                </TextStyle>
                <TextStyle type={'r_15'}>{detailStore.content?.name}</TextStyle>
              </ProductInfoWrap>
              <ProductIconWrap>
                <IconWrap
                  onClick={() => {
                    onCopyContent(presentToast, {
                      content: `${process.env.REACT_APP_STO_URL}${match.url}`,
                      successMsg: '해당 작품 링크가 복사되었습니다!',
                      failureMsg: '작품 링크 복사에 실패하였습니다.',
                    })
                  }}
                >
                  <IonIcon icon={shareSocialOutline} />
                </IconWrap>
              </ProductIconWrap>
            </ProductHeaderContainer>
            <IonRouterLink color={'dark'} routerLink={`/myPage/asset/${match.params.productId}/community`}>
              <CommunityBox>
                <IonIcon className="grid" icon={gridOutline}></IonIcon>
                <TextWrap>
                  <TextStyle type={'r_15'}>해당 작품 커뮤니티</TextStyle>
                </TextWrap>
                <IonIcon icon={chevronForward}></IonIcon>
              </CommunityBox>
            </IonRouterLink>
            {/* 조각 판매중 */}
            {detailStore.content?.status === 'SALE' && (
              <>
                <BetweenWrap>
                  <TextStyle type="r_15">판매 기간</TextStyle>
                  <TextStyle type="b_15">
                    {`${moment(new Date(detailStore.content?.activeProductSale.releaseDate)).format(
                      'YYYY.MM.DD',
                    )} ~ ${moment(new Date(detailStore.content?.activeProductSale.untilDate)).format('YYYY.MM.DD')}`}
                  </TextStyle>
                </BetweenWrap>
                <BetweenWrap>
                  <TextStyle type="r_15">판매율</TextStyle>
                  <TextStyle type="b_15">{amountString(String(myStore.saleRate), false, 2)} %</TextStyle>
                  {/* <TextStyle type="b_15">{amountString(String(saleCountRate), false, 2)} %</TextStyle> */}
                </BetweenWrap>
                <BetweenWrap>
                  <TextStyle type="r_15">전체 조각 수</TextStyle>
                  <TextStyle type="b_15">
                    <IonText>{`${amountString(detailStore.content?.tokenCount.toString())} 개` || '-'}</IonText>
                  </TextStyle>
                </BetweenWrap>
                <BetweenWrap>
                  <TextStyle type="r_15">남은 조각 수</TextStyle>
                  <TextStyle type="b_15">
                    <IonText>
                      {`${amountString(detailStore.content?.activeProductSale.remainCount.toString())} 개` || '-'}
                    </IonText>
                  </TextStyle>
                </BetweenWrap>
              </>
            )}
            {/* 투표중 */}
            {detailStore.content?.status === 'VOTE' && (
              <>
                <BetweenWrap>
                  <TextStyle type="r_15">투표 기간</TextStyle>
                  <TextStyle type="b_15">
                    {`${moment(new Date(detailStore.content?.activeProductVote.createdDate)).format(
                      'YYYY.MM.DD',
                    )} ~ ${moment(new Date(detailStore.content?.activeProductVote.untilDate)).format('YYYY.MM.DD')}`}
                  </TextStyle>
                </BetweenWrap>
                <BetweenWrap>
                  <TextStyle type="r_15">투표율</TextStyle>
                  <TextStyle type="b_15">
                    {`${amountString(String(myStore.voteRateDetail), false, 2)} %` || '-'}
                  </TextStyle>
                </BetweenWrap>
              </>
            )}
            {/* 매각 진행중 */}
            {detailStore.content?.status === 'SELL' && (
              <>
                <BetweenWrap>
                  <TextStyle type="r_15">찬성 수량</TextStyle>
                  <TextStyle type="b_15">
                    <IonText>
                      {`${amountString(detailStore.content?.activeProductVote.approveCount.toString()) ?? 0} 표`}
                    </IonText>
                  </TextStyle>
                </BetweenWrap>
                <BetweenWrap>
                  <TextStyle type="r_15">반대 수량</TextStyle>
                  <TextStyle type="b_15">
                    <IonText>
                      {`${amountString(detailStore.content?.activeProductVote.rejectCount.toString()) ?? 0} 표`}
                    </IonText>
                  </TextStyle>
                </BetweenWrap>
                <BetweenWrap>
                  <TextStyle type="r_15">매각 예상 금액</TextStyle>
                  <TextStyle type="b_15">
                    <IonText>{`${amountString(
                      detailStore.content?.activeProductVote.salePrice.toString() ?? 0,
                    )} 원`}</IonText>
                  </TextStyle>
                </BetweenWrap>
              </>
            )}
            {/* 트레이드 중 */}
            {detailStore.content?.status === 'TRADE' && (
              <>
                <BetweenWrap>
                  <TextStyle type="r_15">총 판매 금액</TextStyle>
                  <TextStyle type="b_15">
                    <IonText>{`${amountString(detailStore.content?.totalTradeBalance?.toString()) ?? 0} 원`}</IonText>
                  </TextStyle>
                </BetweenWrap>
                <BetweenWrap>
                  <TextStyle type="r_15">누적 판매 조각 수</TextStyle>
                  <TextStyle type="b_15">
                    <IonText>{`${amountString(detailStore.content?.totalTradeCount?.toString()) ?? 0} 개`}</IonText>
                  </TextStyle>
                </BetweenWrap>
              </>
            )}
            {/* 매각 완료 */}
            {detailStore.content?.status === 'FINISH' && (
              <>
                <BetweenWrap>
                  <TextStyle type="r_15">보유 기간</TextStyle>
                  <TextStyle type="b_15">
                    {`${moment(new Date(detailStore.content?.activeProductSale.releaseDate)).format(
                      'YYYY.MM.DD',
                    )} ~ ${moment(new Date(detailStore.content?.activeProductVote.expectedSellDate)).format(
                      'YYYY.MM.DD',
                    )}`}
                  </TextStyle>
                </BetweenWrap>
                <BetweenWrap>
                  <TextStyle type="r_15">수익률</TextStyle>
                  <TextStyle type="b_15">
                    <IonText>{`${amountString(String(myStore.priceRate), false, 2) ?? 0} %`}</IonText>
                  </TextStyle>
                </BetweenWrap>
              </>
            )}
            {detailStore.content?.contents?.map((d, i) => (
              <CategoryWrap key={i}>
                <IonText className={d.type === 'header' ? 'category-title' : 'category-content'}>
                  {d.content || '-'}
                </IonText>
              </CategoryWrap>
            ))}
          </ContentContainer>
        </DetailContent>
      </IonContent>
    </IonPage>
  )
})

const ImgWrap = styled.div`
  width: 100%;
  aspect-ratio: 1/1;
  display: flex;
  text-align: center;
  justify-content: center;
  img {
    object-fit: contain;
  }
`

const ContentContainer = styled.div`
  padding: 25px 20px;
`

const CommunityBox = styled.div`
  margin: 30px 0;
  width: 100%;
  background-color: var(--ion-color-gray100);
  padding: 17px 8px 17px 23px;
  border-radius: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  ion-icon {
    font-size: 24px;
  }
`

const TextWrap = styled.div`
  margin-left: 15px;
  width: 100%;
`

const BetweenWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`

const CategoryWrap = styled.div`
  display: flex;
  flex-direction: column;
  white-space: pre-line;
  .category-title {
    font-weight: 900;
    font-size: 20px;
    margin: 20px 0;
  }
  .category-content {
    font-size: 15px;
    margin-bottom: 20px;
  }
`

const ProductHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ProductInfoWrap = styled.div`
  display: flex;
  flex-direction: column;
`

const ProductIconWrap = styled.span`
  min-width: 30px;
  max-height: 30px;
  font-size: 20px;
  margin-top: 7px;
`

const IconWrap = styled.span`
  font-size: 25px;
  cursor: pointer;
`
